import {
  Button,
  FullscreenDialog,
  Text,
  VSpacer,
} from '@/components/DesignSystem';
import {
  NotificationRecipientsContent,
} from '@/pages/Admin/NotificationBuilder/components/NotificationRecipientsContent';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/GetApp';
import { IconButton, Stack } from '@mui/material';
import { FilterOptions, CSVRecipientData } from '@shared/interfaces/ScheduledNotification';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationRecipientsModalProps {
  onClose: () => void,
  options: FilterOptions,
  csvRecipientsData: CSVRecipientData,
  retailerId: string,
  scheduledNotificationId?: string,
}

export const NotificationRecipientsModal = ({
  onClose,
  options,
  csvRecipientsData = [],
  retailerId,
  scheduledNotificationId,
}: NotificationRecipientsModalProps) => {
  const { t } = useTranslation();
  const [showExportConfirmationDialog, setShowExportConfirmationDialog] = useState(false);

  return (
    <FullscreenDialog
      hideHeader
      onClose={onClose}
      open
      testID="notification-recipients-modal"
    >
      <Stack alignItems="flex-start" marginLeft="-14px">
        <IconButton
          aria-label="close"
          data-testid="notification-recipients-modal-close-icon"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <Text category="title-large">
          {t($ => $.notificationBuilder.modal.recipients.title)}
        </Text>
        <Button
          color="primary"
          disableElevation
          endIcon={<DownloadIcon fontSize="small" />}
          onClick={() => setShowExportConfirmationDialog(true)}
          testID="notification-recipients-modal-download-csv"
          variant="text"
        >
          {t($ => $.notificationBuilder.actions.downloadCsv)}
        </Button>
      </Stack>
      <VSpacer size="2" />
      <NotificationRecipientsContent
        csvRecipientData={csvRecipientsData}
        onExportDialogClose={() => setShowExportConfirmationDialog(false)}
        options={options}
        retailerId={retailerId}
        scheduledNotificationId={scheduledNotificationId}
        showExportDialog={showExportConfirmationDialog}
      />
    </FullscreenDialog>
  );
};
